import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaScrollbar from './VaScrollbar.vue'

export default withConfigTransport(VaScrollbar)
